export default __webpack_public_path__ + "static/media/q2.adde218c.jpg";